import api from './api';

export const getAvaliacaoById = async id => {
  const response = await api.get(`/avaliacao/${id}`);
  return response.data;
};

export const getAvaliacoesByPac = async codPac => {
  const response = await api.get(`/avaliacoes/${codPac}`);
  return response.data;
};
